<script>
  export default {
    props: {
      customClass: {
        type: String,
        default: 'fill-primary svg-text-white',
      },
      disableHover: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<template>
  <svg
    :class="[customClass, { 'no-hover': disableHover }]"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6019 29H7.10255C5.93782 29 5 28.068 5 26.9183V3.08168C5 1.93161 5.94658 1 7.11424 1H17.6316V7.22419C17.6316 8.37675 18.5769 9.2963 19.7431 9.2963H25V19.1462C24.1899 18.8134 23.3009 18.6296 22.3684 18.6296C18.5896 18.6296 15.5263 21.6476 15.5263 25.3704C15.5263 26.7067 15.921 27.9523 16.6019 29V29V29Z" />
    <path d="M13.3981 29H22.8975C24.0622 29 25 28.3787 25 27.6123V11.7212C25 10.9544 24.0534 10.3334 22.8858 10.3334H12.3684V14.4828C12.3684 15.2512 11.4231 15.8642 10.2569 15.8642H5V22.4309C5.8101 22.209 6.69905 22.0865 7.63158 22.0865C11.4104 22.0865 14.4737 24.0984 14.4737 26.5803C14.4737 27.4712 14.079 28.3016 13.3981 29V29V29Z" />
    <path d="M18.6842 1V7.21918C18.6842 7.7936 19.1589 8.25926 19.7271 8.25926H25L18.6842 1V1Z" />
    <text :class="{ 'no-hover': disableHover }" x="9" y="18">S.P.</text>
  </svg>
</template>
